import React, { createContext, useContext, useState } from "react";

const ChatContext = createContext();

export function useChatContext() {
  const context = useContext(ChatContext);
  if (!context) {
    throw new Error("useChatContext must be used within a ChatProvider");
  }
  return context;
}

export function ChatProvider({ children }) {
  const [isChatOpen, setIsChatOpen] = useState(false);
  // Optional prompt to pre-fill into the chat input when it next opens.
  // Consumed (and cleared) by AIChatPanel on open.
  const [initialPrompt, setInitialPrompt] = useState(null);

  const toggleChat = () => setIsChatOpen(!isChatOpen);
  const closeChat = () => setIsChatOpen(false);
  const openChat = (prompt = null) => {
    if (prompt) setInitialPrompt(prompt);
    setIsChatOpen(true);
  };
  const clearInitialPrompt = () => setInitialPrompt(null);

  return (
    <ChatContext.Provider
      value={{ isChatOpen, toggleChat, closeChat, openChat, initialPrompt, clearInitialPrompt }}
    >
      {children}
    </ChatContext.Provider>
  );
}
